import { Box, Drawer, Typography } from '@mui/material';
import React from 'react';
import { IBottomDrawer } from './IBottomDrawer';

const BottomDrawer = ({ open, setOpen, text, title }: IBottomDrawer) => {


    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
            return;
        }
        setOpen(open);
    };

    return (
        <div>
            <Drawer
                anchor="bottom"
                open={open}
                onClose={toggleDrawer(false)}
                sx={{ direction: "rtl", position: "relative" }}
                PaperProps={{
                    sx: {
                        backgroundColor: "transparent",
                    },
                }}
            >
                <Box
                    sx={{
                        padding: 2,
                        textAlign: 'center',
                        width: '100%',
                        height: '200px',
                        backgroundColor: "var(--input-bg-color)"
                    }}
                >
                    <Typography gutterBottom sx={{ color: "var(--primary-text-color)", textAlign: "start", fontSize: ".9rem" }}>
                        {title}
                    </Typography>
                    <div style={{ textAlign: "center", width: "100%", height: "100%", display: "flex", justifyContent: "center" }}>
                        <Typography sx={{ top: '75px', position: "absolute", fontSize: ".8rem", fontWeight: "bold", color: "var(--primary-text-color)" }}>
                            {text}
                        </Typography>
                    </div>
                </Box>
            </Drawer>
        </div>
    );
};

export default BottomDrawer;
